import { Action } from '@ngrx/store';

// Create entertainment event booking
export const CREATE_BOOKING = '[Entertainment Event] Create Booking';
export const CREATE_BOOKING_SUCCESS = '[Entertainment Event] Create Booking Success';
export const CREATE_BOOKING_FAIL = '[Entertainment Event] Create Booking Failure';

export class CreateBooking implements Action {
  readonly type = CREATE_BOOKING;
  constructor(public payload: any) {}
}

export class CreateBookingSuccess implements Action {
  readonly type = CREATE_BOOKING_SUCCESS;
  constructor(public payload: any) {}
}

export class CreateBookingFail implements Action {
  readonly type = CREATE_BOOKING_FAIL;
  constructor(public payload: any) {}
}

export const UPDATE_BOOKING = '[Entertainment Event] Update Booking';
export const UPDATE_BOOKING_SUCCESS = '[Entertainment Event] Update Booking Success';
export const UPDATE_BOOKING_FAIL = '[Entertainment Event] Update Booking Fail';

export class UpdateBooking implements Action {
  readonly type = UPDATE_BOOKING;
  constructor(public payload: any) {}
}

export class UpdateBookingSuccess implements Action {
  readonly type = UPDATE_BOOKING_SUCCESS;
  constructor(public payload: any) {}
}

export class UpdateBookingFail implements Action {
  readonly type = UPDATE_BOOKING_FAIL;
  constructor(public payload: any) {}
}

export const VIEW_BOOKING = '[Entertainment Event] View Booking';
export const VIEW_BOOKING_SUCCESS = '[Entertainment Event] View Booking Success';
export const VEIW_BOOKING_FAIL = '[Entertainment Event] View Booking Fail';

export class ViewBooking implements Action {
  readonly type = VIEW_BOOKING;
  constructor(public payload: any) {}
}

export class ViewBookingSuccess implements Action {
  readonly type = VIEW_BOOKING_SUCCESS;
  constructor(public payload: any) {}
}

export class ViewBookingFail implements Action {
  readonly type = VEIW_BOOKING_FAIL;
  constructor(public payload: any) {}
}

export const RESET_BOOKING = '[Entertainment Event] Reset Booking';

export class ResetBooking implements Action {
  readonly type = RESET_BOOKING;
}

export const UPDATE_BOOKING_ORDER = '[Entertainment Event] Update Booking Order';
export const UPDATE_BOOKING_ORDER_SUCCESS = '[Entertainment Event] Update Booking Order Success';
export const UPDATE_BOOKING_ORDER_FAIL = '[Entertainment Event] Update Booking Order Fail';

export class UpdateBookingOrder implements Action {
  readonly type = UPDATE_BOOKING_ORDER;
  constructor(public payload: any) {}
}
export class UpdateBookingOrderSuccess implements Action {
  readonly type = UPDATE_BOOKING_ORDER_SUCCESS;
  constructor(public payload: any) {}
}
export class UpdateBookingOrderFail implements Action {
  readonly type = UPDATE_BOOKING_ORDER_FAIL;
  constructor(public payload: any) {}
}

export type EntertainmentEventBookingAction =
  | CreateBooking
  | CreateBookingSuccess
  | CreateBookingFail
  | UpdateBooking
  | UpdateBookingSuccess
  | UpdateBookingFail
  | ViewBooking
  | ViewBookingSuccess
  | ViewBookingFail
  | ResetBooking
  | UpdateBookingOrder
  | UpdateBookingOrderSuccess
  | UpdateBookingOrderFail;
